import { Fragment } from "react";

export function renderBrandText(text) {
  if (typeof text !== "string") {
    return text;
  }

  const brandPattern = /(TheQAHub Academy|TheQAHub|Academy)/g;

  if (!brandPattern.test(text)) {
    return text;
  }

  const parts = text.split(brandPattern);

  return parts.map((part, index) => {
    if (part === "TheQAHub Academy") {
      return (
        <span key={`brand-${index}`} className="academy-wordmark" translate="no">
          <span className="academy-wordmark-hub theqahub-font">TheQAHub</span>
          <span className="academy-wordmark-academy">ACADEMY</span>
        </span>
      );
    }

    if (part === "TheQAHub") {
      return (
        <span key={`brand-${index}`} className="theqahub-font" translate="no">
          TheQAHub
        </span>
      );
    }

    if (part === "Academy") {
      return (
        <span key={`brand-${index}`} className="academy-wordmark-academy" translate="no">
          ACADEMY
        </span>
      );
    }

    return <Fragment key={`part-${index}`}>{part}</Fragment>;
  });
}
